import React from 'react';
import cn from 'clsx';
import { Skeleton } from '@pkgs/components/components/Skeleton/Skeleton';

import { type IListItemProps, ListItem } from '@/components/property-expose/ListItem';

import styles from './IconList.module.css';

export interface IIconListProps {
  className?: string;
  items: (Pick<IListItemProps, 'label' | 'icon'> & {
    id: string;
    isLoading?: boolean;
    dataTestId?: string;
  })[];
  'data-testid'?: string;
  'data-restricted'?: boolean;
}

export const IconList = ({ className, items, 'data-testid': dataTestId, 'data-restricted': dataRestricted }: IIconListProps) => {
  return (
    <ul className={cn(styles.list, className)} data-testid={dataTestId} data-restricted={dataRestricted}>
      {items.map((item) => (
        <li key={item.id}>
          <Skeleton loading={item.isLoading ?? false}>
            <ListItem data-testid={item.dataTestId ?? item.label.replaceAll(' ', '-')} label={item.label} icon={item.icon} as="div" />
          </Skeleton>
        </li>
      ))}
    </ul>
  );
};
